import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import {
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    MenuItem,
    Alert as MuiAlert,
    Snackbar,
    TextField,
    Typography
} from "@mui/material";
import { Col } from "antd";
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { configUrl } from '../config';
import getAllSubscriptionsService from '../services/OwnTestCreationServices/getAllSubscriptionsService';

const CollegePredictor = ({ isLoggedIn, handleShowSubcription }) => {

    const navigate = useNavigate();
    // const [price] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);

    const [branchOptions, setBranchOptions] = useState([
        "AI & Data Science",
        "Aeronautical & Automotive",
        "Architectural & Planning",
        "Biomedical & Biotechnology",
        "Civil",
        "Computer",
        "Electrical & Electronics",
        "Mechanical",
        "Pharmaceutical & Oil",
        "Information Technology"
    ]);
    const [cityOptions, setCityOptions] = useState([
        "Ahmednagar",
        "Amravati",
        "Aurangabad",
        "Jalgaon",
        "Kolhapur",
        "Mumbai",
        "Nagpur",
        "Nanded",
        "Nandurbar",
        "Nashik",
        "Navi Mumbai",
        "Parbhani",
        "Pune",
        "Raigad",
        "Ratnagiri",
        "Satara",
        "Shirpur",
        "Solapur",
        "Thane",
        "Wardha"
    ]);
    const [loading, setLoading] = useState(false)

    const [rank, setRank] = useState("");
    const [preferredBranch, setPreferredBranch] = useState("");
    const [locationPreference, setLocationPreference] = useState("");
    const [openForm, setOpenForm] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState([]);
    const [severty, setSeverty] = useState('warning');
    const [colleges] = useState([
        {
            "College Code": 3012,
            "Branch Code": "301224510",
            "Category": "GOBCS",
            "Branch": "Computer Engineering",
            "City": "Mumbai",
            "College": "Veermata Jijabai Technological Institute(VJTI), Matunga, Mumbai",
            "Highest Rank": 667,
            "Percentile": 99.7498822,
            "Rank": 667,
            "Round": 2,
            "Round 1 Percentile": 99.8171846,
            "Round 1 Rank": 468,
            "Round 2 Percentile": 99.7498822,
            "Round 2 Rank": 667,
            "Stage": "I",
            "SI": 60,
            "Highest Percentile": 99.8171846,
            "AbbreviatedName": "VJTI, Mumbai"
        },
        {
            "College Code": 16006,
            "Branch Code": "1600661210",
            "Category": "GOPENS",
            "Branch": "Mechanical Engineering",
            "City": "Pune",
            "College": "COEP Technological University",
            "Highest Rank": 2044,
            "Percentile": 99.3496503,
            "Rank": 2044,
            "Round": 2,
            "Round 1 Percentile": 99.4352449,
            "Round 1 Rank": 1756,
            "Round 2 Percentile": 99.3496503,
            "Round 2 Rank": 2044,
            "Stage": "I",
            "SI": 150,
            "Highest Percentile": 99.4352449,
            "AbbreviatedName": "COEP, Pune"
        },
        {
            "College Code": 3014,
            "Branch Code": "301461210",
            "Category": "GOPENS",
            "Branch": "Mechanical Engineering",
            "City": "Andheri",
            "College": "Sardar Patel College of Engineering, Andheri",
            "Highest Rank": 3122,
            "Percentile": 99.1923077,
            "Rank": 2612,
            "Round": 2,
            "Round 1 Percentile": 99.0517692,
            "Round 1 Rank": 3122,
            "Round 2 Percentile": 99.1923077,
            "Round 2 Rank": 2612,
            "Stage": "I",
            "SI": 60,
            "Highest Percentile": 99.1923077,
            "AbbreviatedName": "Sardar Patel College, Andheri"
        }
    ])
    const [loadingSignUp, setSignUpLoading] = useState(false);

    // const [subscription, setSubscriptions] = useState([]);
    // console.log(subscription, '-subs in cp')
    // const getAllSubscriptions = async () => {
    //     const subscriptions = await getAllSubscriptionsService();
    //     setSubscriptions(subscriptions);
    // }
    // useEffect(() => {
    //     getAllSubscriptions();
    // }, [])

    // Validation logic
    const validateFields = () => {
        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedMobile = mobile.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[0-9]{10}$/;
        if (!trimmedName) {
            setShowError("Name is required");
            setSeverty("error");
            setOpen(true);
            return false;
        }
        else if (!trimmedEmail) {
            setShowError("Email is required");
            setSeverty("error");
            setOpen(true);
            return false;
        } else if (!emailRegex.test(trimmedEmail)) {
            setShowError("Enter a valid email address");
            setSeverty("error");
            setOpen(true);
            return false;
        }

        if (trimmedMobile && !mobileRegex.test(trimmedMobile)) {
            setShowError("Enter a valid 10-digit mobile number");
            setSeverty("error");
            setOpen(true);
            return false;
        }

        return true;
    };



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
        setShowError("");
    };
    const onNextHandle = async () => {
        setSignUpLoading(true);
        const subscription = await getAllSubscriptionsService();
        console.log(subscription, '-subs respincp')
        const series = {
            subscriptionTypeId: subscription[1]?.subscriptionTypeId,
            courseId: subscription[1]?.subscriptionTypeId ?? 0,
            price: subscription[1]?.price ?? 0,
        };
        const ResourceTypeId = 4;
        if (isLoggedIn) {
            setShowCheckout(true);
        } else {
            handleShowSubcription('#college-predictor');
            navigate("/medineer/SignUp", { state: { series, ResourceTypeId } });
        }
        setSignUpLoading(false);
    };

    const onPredictClick = () => {
        if (!rank || !preferredBranch || !locationPreference) {
            setOpen(true);
            setShowError("Please fill Percentile, Branch, and Location first");
            setSeverty('error');
            setLoading(false);
            return;
        }
        setOpenForm(true);
    };

    const handleSubmit = async () => {
        if (validateFields()) {
            let FeatureKey = "college_predictor"
            const payload = {
                "Name": name,
                "Email": email,
                "Mobile": mobile,
                FeatureKey,
                "Percentile": rank,
                "Branch": preferredBranch,
                "City": locationPreference
            };

            try {
                setLoading(true);
                let resp = await axios.post(`${configUrl.AssessmentServer}/api/User/FeatureRecord`, payload);
                if (resp.data?.allowed == true) {
                    setOpen(true);
                    setShowError("Thanks! Please check your email for your personalized college list.");
                    setSeverty('success');
                } else {
                    setOpen(true);
                    setShowError("Oh! Please subscribe to the College Predictor feature to receive updates and alerts throughout the admission process.");
                    setSeverty('warning');
                }
                setLoading(false);
                setOpenForm(false);
                setName(null);
                setMobile(null);
                setEmail(null);
                setRank("")
                setPreferredBranch(null)
                setLocationPreference(null)

            } catch (error) {
                console.error("Error saving data:", error);
                // alert("Something went wrong.");
                setOpen(true);
                setShowError("Something went wrong.");
                setSeverty('error');
                setLoading(false);
            }
        }
    };



    // useEffect(() => {
    //     const fetchFilters = async () => {
    //         try {
    //             const response = await axios.get(`${configUrl.PredictorServer}/getFilters`);
    //             const data = response.data;

    //             const uniqueBranches = Array.from(new Set(data?.branches || []));
    //             setBranchOptions(uniqueBranches);
    //             setCityOptions(data?.cities || []);
    //         } catch (error) {
    //             console.error("Error fetching filter options:", error);
    //         }
    //     };
    //     fetchFilters();
    // }, []);

    return (
        <Box
            id="predictor"
            sx={{
                position: "relative",
                py: { xs: 8, md: 12 },
                bgcolor: "white",
                overflow: "hidden",
            }}
        >
            {/* Background Circles */}
            <Box
                sx={{
                    position: "absolute",
                    top: -100,
                    left: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "secondary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />

            <Box sx={{ position: "relative", zIndex: 2, px: 2, maxWidth: 1200, mx: "auto" }}>
                <Grid container spacing={6}>
                    {/* LEFT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5, mb: 2, bgcolor: "secondary.light", px: 2, py: 1, borderRadius: 5, background: '#ECEED1' }}>
                            <EmojiEventsIcon size={20} color="#1976d2" />
                            <Typography fontWeight={600} color="primary.main" fontSize={'1.4rem'}>
                                College Predictor
                            </Typography>
                        </Box>

                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: '4.8rem',
                                textAlign: 'left',
                                fontWeight: 700,
                                mb: 2,
                                lineHeight: 1.2,
                                color: "#242e42",
                            }}
                        >
                            Know Your{" "}
                            <Box component="span" sx={{ color: "primary.main" }}>
                                Dream College
                            </Box>{" "}
                            Chances
                        </Typography>

                        <Typography variant="h6" mb={4} sx={{ fontSize: '2rem', lineHeight: '2.8rem', color: '#6c7993', textAlign: 'left' }}>
                            Stay ahead of the competition! Predict your admission chances early with insights from previous year cut-offs.
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                            {[
                                {
                                    icon: <TrendingUpIcon sx={{ color: '#13ACCA', fontSize: '2rem' }} />,
                                    title: "Personalized College Predictions",
                                    desc: "Assess your chances of admission based on category, city etc.",
                                    bgcolor: '#05a7c71a'
                                },
                                {
                                    icon: <LocationOnIcon sx={{ color: "#FFCD35", fontSize: '2rem' }} />,
                                    title: "AI-Based College Recommendations",
                                    desc: "Leverage AI technology to predict the most suitable colleges.",
                                    bgcolor: '#ffcc331a'
                                },
                                // {
                                //     icon: <AssistantIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                //     title: "Strategic College Planning",
                                //     desc: "Optimize your college admission strategy.",
                                //     bgcolor: '#e7eff5'
                                // },
                                {
                                    icon: <SchoolIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                    title: "One-Stop Admissions Hub",
                                    desc: "College Predictor for PCM, PCB, JEE, NEET, and MBA aspirants.",
                                    bgcolor: '#f46d341a'
                                },
                            ].map((item, i) => (
                                <Box key={i} sx={{ display: "flex", gap: 2, textAlign: 'left' }}>
                                    <Box
                                        sx={{
                                            p: 1,
                                            borderRadius: "50%",
                                            bgcolor: item.bgcolor, //"grey.100",
                                            height: 36,
                                            width: 36,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} sx={{ fontSize: '1.6rem', color: '#242e42' }}>{item.title}</Typography>
                                        <Typography variant="body2" sx={{ fontSize: '1.4rem', color: '#6c7993' }}>
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<SchoolIcon />}
                            sx={{
                                mt: 4,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: '1.4rem',
                                background: 'linear-gradient(135deg, hsl(45 100% 60%), hsl(18 90% 58%))',
                                color: '#fff',
                                float: 'left'
                            }}
                            onClick={onNextHandle}
                        >
                            {loadingSignUp ? 'Loading...' : 'Get College Predictor @ ₹1000'}
                        </Button>
                    </Grid>

                    {/* RIGHT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Card elevation={4} sx={{ borderRadius: 3 }}>
                            <CardContent sx={{ p: 4 }}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                                    {/* Expected Rank */}
                                    <Box>
                                        <Typography variant="body2" sx={{ mb: 1, textAlign: 'left', fontSize: '1.4rem', fontWeight: 500, color: '#6c7993' }}>
                                            Your Percentile
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            placeholder="Enter your Percentile"
                                            variant="outlined"
                                            value={rank}
                                            onChange={(e) => setRank(e.target.value)}
                                            sx={{
                                                bgcolor: 'grey.50',
                                                borderRadius: 2,
                                                '& .MuiOutlinedInput-input': {
                                                    fontSize: '1.4rem', // input text size
                                                    '::placeholder': {
                                                        fontSize: '1.4rem', // placeholder size
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>

                                    {/* Preferred Branch Dropdown */}
                                    <Box>
                                        <Typography variant="body2" sx={{ mb: 1, textAlign: 'left', fontSize: '1.4rem', fontWeight: 500, color: '#6c7993' }}>
                                            Preferred Branch
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            value={preferredBranch}
                                            onChange={(e) => setPreferredBranch(e.target.value)}
                                            placeholder="Select branch"
                                            sx={{ bgcolor: 'grey.50', borderRadius: 2 }}
                                            InputProps={{
                                                style: {
                                                    fontSize: "1.5rem", // Font size for the input text
                                                    textAlign: "left"
                                                },
                                            }}
                                        >
                                            {branchOptions.map((branch, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={branch}
                                                    sx={{
                                                        fontSize: "1.5rem",
                                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                                    }}
                                                >
                                                    {branch}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Box>

                                    {/* Location Preference Dropdown */}
                                    <Box>
                                        <Typography variant="body2" sx={{ mb: 1, textAlign: 'left', fontSize: '1.4rem', fontWeight: 500, color: '#6c7993' }}>
                                            Location Preference
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            value={locationPreference}
                                            onChange={(e) => setLocationPreference(e.target.value)}
                                            placeholder="Select location"
                                            sx={{ bgcolor: 'grey.50', borderRadius: 2 }}
                                            InputProps={{
                                                style: {
                                                    fontSize: "1.5rem", // Font size for the input text
                                                    textAlign: "left"
                                                },
                                            }}
                                        >
                                            {cityOptions.map((city, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={city}
                                                    sx={{
                                                        fontSize: "1.5rem",
                                                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                                    }}
                                                >
                                                    {city}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Box>

                                    <Divider sx={{ color: '#242e42', borderColor: '#242e42' }} />

                                    <Typography variant="subtitle2" sx={{ color: '#6c7993', textAlign: 'left', fontSize: '1.4rem' }}>
                                        Predicted Colleges:
                                    </Typography>

                                    {colleges.map((college, index) => (
                                        <Col key={index}>
                                            <Card style={{ backgroundColor: '#ffff', margin: '0px' }} className='card'>
                                                <div className='floatingHeadWait'>
                                                    <div>{college.Category}</div>
                                                    <div>{college["Highest Rank"]}</div>
                                                    <div className="percentileText">
                                                        {`${parseFloat(college["Highest Percentile"]).toFixed(2)}`}
                                                    </div>

                                                </div>
                                                <div>
                                                    <h4 className='notificationTextTitle'>
                                                        {`${college?.AbbreviatedName || college?.College} (${college["College Code"]})`}
                                                        {/* <Tooltip
                                                                                        title={college.College}
                                                                                        color="blue"
                                                                                        trigger="click"
                                                                                    >
                                                                                        <div className="info-icon">
                                                                                            <InfoCircleOutlined />
                                                                                        </div>
                                                                                    </Tooltip> */}
                                                    </h4>
                                                    <h5 className="notificationText">
                                                        {college.Branch}{` (${college["Branch Code"]})`}&nbsp;
                                                    </h5>
                                                    <h5 className="notificationText" style={{ marginTop: 5 }}>
                                                        {`Overall Seats: ${college["SI"]}`}&nbsp;
                                                    </h5>
                                                </div>

                                            </Card>
                                        </Col>
                                    ))}

                                    {/* {[1, 2, 3].map((i) => (
                                        <Box
                                            key={i}
                                            sx={{
                                                display: "flex",
                                                gap: 2,
                                                alignItems: "center",
                                                p: 2,
                                                borderRadius: 2,
                                                border: "1px solid",
                                                borderColor: "#d7e7ea",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    bgcolor: "#0B3054",
                                                    color: "white",
                                                    fontWeight: 700,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {i}
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ height: 10, bgcolor: "grey.200", borderRadius: 1, width: "75%", mb: 1 }} />
                                                <Box sx={{ height: 8, bgcolor: "grey.300", borderRadius: 1, width: "50%" }} />
                                            </Box>
                                        </Box>
                                    ))} */}

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        size="large"
                                        sx={{
                                            mt: 2,
                                            borderRadius: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            padding: '1.2rem 2.2rem',
                                            fontSize: '1.4rem',
                                            color: '#fff',
                                            background: '#0B3054',
                                        }}
                                        onClick={onPredictClick}
                                    >
                                        Predict My Colleges
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={5000}>
                <MuiAlert
                    severity={severty} //"error"
                    onClose={handleClose}
                    sx={{
                        fontSize: "15px",
                        width: "100%",
                        //  backgroundColor: '#f69d9dff', 
                        color: '#000'
                    }}
                >
                    {showError}
                </MuiAlert>
            </Snackbar>
            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        fontFamily:
                            'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        backgroundColor: "#0B3054", // dark blue
                        color: "#fff",
                        textAlign: "left",
                        py: 2,
                        display: 'inline-flex',
                        alignItem: 'center'
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))', // orange background
                            borderRadius: 2,
                            width: 42,
                            height: 42,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: '1rem'
                        }}
                    >
                        <MailOutlineIcon sx={{ color: "#0B3054", fontSize: '2.5rem' }} />
                    </Box>
                    <Box>
                        Get Your College List
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    {/* Subtext */}
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 2,
                            textAlign: "left",
                            fontSize: "2rem",
                            color: "#4a4a4a",
                            fontWeight: '600',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        }}
                    >
                        Get your college list by email—just fill in your details.
                    </Typography>
                    <TextField
                        label="Name"
                        fullWidth
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Email"
                        type="email"
                        required
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Mobile"
                        fullWidth
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button
                        onClick={() => setOpenForm(false)}
                        variant="outlined"
                        // sx={{ textTransform: "none" }}
                        // variant="contained"
                        size="large"
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            border: '1px solid #0B3054',
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#0B3054',
                            // background: '#0B3054',
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        disabled={loading}
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#fff',
                            background: '#0B3054',
                            '&:disabled': { backgroundColor: '#0B3054a1' }
                        }}
                        onClick={() => handleSubmit()}
                    >
                        {loading ? 'Loading...' :
                            "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
export default CollegePredictor;
